import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseBlockedSearch } from "@/features/accounts";
import { BlockedSpecialistsPage } from "@/features/accounts/pages";
import { strictSearch } from "@/shared/lib/search";

/** The specialists whose sign-in is blocked: hg-auth's list, under the specialists. */
export const Route = createFileRoute("/_app/specialists/blocked")({
  validateSearch: strictSearch(parseBlockedSearch),
  component: Blocked,
});

function Blocked() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <BlockedSpecialistsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(userId) =>
        router.buildLocation({ to: "/specialists/$userId", params: { userId } }).href
      }
      onOpen={(userId) => void router.navigate({ to: "/specialists/$userId", params: { userId } })}
    />
  );
}
